import { ElementRef, Injectable, Renderer2 } from '@angular/core';
import { ObservableService } from './observable.service';
import { Subject } from 'rxjs';
import { AnimationController, NavController, PopoverController } from '@ionic/angular';
import { PopoverContentComponent } from '../components/popover-content/popover-content.component';
import { PageRoutes } from '../app-routing.module';
import { Platform } from '@ionic/angular';



// abrir modal para criar agendamento

// agenda
// ...
// - data do agendamento
// - horário do agendamento
// - duração?
// - valor?
// - atendimento avulso + vencimento
// - agendamento criado (se precisar editar, é só clicar)
// - fechar agenda para voltar

// client profile
// - mostrar aba com atendimentos?
// - faturas
// - lista de faturas
// - novo pagamento
// - data do pagamento
// - metodo
// - info adicional?
// - faturas que podem ser pagas
// - fechado / pago?
// - exibir pagamentos
// - ver um pagamento?

// relatorio
// - filtro de data
// - total
// - pago
// - pendente
// - listagem geral, mas novos pagamentos só são permitidos para um cliente por vez 



export enum OnboardingAction {
  FIRST_LOGIN = 'first-login',
  ONBOARDING_START = 'onboarding-start',
  LOGIN = 'login',
  VIEW_DASHBOARD = 'view-dashboard',
  VIEW_CLIENTS = 'view-clients',
  ADD_NEW_CLIENT_OPEN = 'add-new-client-open',
  CLIENT_CREATED = 'client-created',
  CLIENT_UPDATED = 'client-updated',
  VIEW_CLIENT_PROFILE = 'view-client-profile',
  VIEW_CLIENT_PROFILE2 = 'view-client-profile2',
  VIEW_CLIENT_PROFILE3 = 'view-client-profile3',
  VIEW_CLIENT_PROFILE_AGENDA = 'view-client-profile-agenda',
  VIEW_CLIENT_PROFILE_AGENDA_VIEW = 'view-client-profile-agenda-view',
  VIEW_CLIENT_PROFILE_APPOINTMENTS = 'view-client-profile-appointments',
  VIEW_CLIENT_PROFILE_APPOINTMENTS_VIEW = 'view-client-profile-appointments-view',
  CLIENT_PROFILE_BACK_FROM_AGENDA = 'client-profile-back-from-agenda',
  CLIENT_PROFILE_VIEW_INVOICES = 'client-profile-view-invoices',
  CLIENT_PROFILE_LIST_INVOICES = 'client-profile-list-invoices',
  CLIENT_PROFILE_NEW_PAYMENT = 'client-profile-new-payment',
  PAYMENT_CREATE_DATE = 'payment-create-date',
  PAYMENT_CREATE_AMOUNT = 'payment-create-amount',
  PAYMENT_CREATE_METHOD = 'payment-create-method',
  PAYMENT_CREATE_DETAILS = 'payment-create-details',
  PAYMENT_CREATE_INVOICE_LIST = 'payment-create-invoice-list',
  PAYMENT_CREATED = 'payment-created',
  PAYMENT_MODAL_CLOSED = 'payment-modal-closed',
  PAYMENT_VIEW_ALL = 'payment-view-all',
  PAYMENT_VIEW_ONE = 'payment-view-one',
  VIEW_AGENDA = 'view-agenda',
  AGENDA_OPENED = 'agenda-opened',
  AGENDA_NAV_NEXT = 'agenda-nav-next',
  AGENDA_NAV_BACK = 'agenda-nav-back',
  AGENDA_NAV_CLOSE = 'agenda-nav-close',
  AGENDA_TIME_SLOT = 'agenda-time-slot',
  APPOINTMENT_CREATE_DATE = 'appointment-create-date',
  APPOINTMENT_CREATE_HOUR = 'appointment-create-hour',
  APPOINTMENT_CREATE_DURATION = 'appointment-create-duration',
  APPOINTMENT_CREATE_AMOUNT = 'appointment-create-amount',
  APPOINTMENT_CREATE_TYPE = 'appointment-create-type',
  APPOINTMENT_CREATE_DUE_DATE = 'appointment-create-due-date',
  APPOINTMENT_CREATED = 'appointment-created',
  APPOINTMENT_MODAL_OPENED = 'appointment-modal-opened',
  APPOINTMENT_MODAL_CLOSE = 'appointment-modal-close',
  APPOINTMENT_MODAL_SAVE = 'appointment-modal-save',
  VIEW_REPORTS = 'view-reports',
  REPORT_FILTER_DATE = 'report-filter-date',
  REPORT_TOTAL = 'report-total',
  REPORT_PAID = 'report-paid',
  REPORT_PENDING = 'report-pending',
  REPORT_LIST = 'report-list',
  VIEW_SETTINGS = 'view-settings',
  SCHEDULE_APPOINTMENT = 'schedule-appointment',
  CLOSE = 'close',
  WAIT = 'wait'
}

const OnboardingSteps: OnboardingAction[] = [
  // OnboardingAction.LOGIN,
  OnboardingAction.VIEW_DASHBOARD,
  OnboardingAction.ONBOARDING_START,
  OnboardingAction.VIEW_CLIENTS,
  OnboardingAction.ADD_NEW_CLIENT_OPEN,
  OnboardingAction.WAIT,
  OnboardingAction.CLIENT_CREATED,
  OnboardingAction.VIEW_CLIENT_PROFILE,
  OnboardingAction.VIEW_CLIENT_PROFILE2,
  OnboardingAction.VIEW_CLIENT_PROFILE3,
  OnboardingAction.VIEW_CLIENT_PROFILE_AGENDA,
  // OnboardingAction.VIEW_CLIENT_PROFILE_APPOINTMENTS_VIEW,
  OnboardingAction.AGENDA_OPENED,
  OnboardingAction.AGENDA_NAV_NEXT,
  OnboardingAction.AGENDA_NAV_BACK,
  OnboardingAction.AGENDA_TIME_SLOT,
  OnboardingAction.WAIT,
  OnboardingAction.APPOINTMENT_MODAL_OPENED,
  OnboardingAction.APPOINTMENT_CREATE_DATE,
  OnboardingAction.APPOINTMENT_CREATE_HOUR,
  OnboardingAction.APPOINTMENT_CREATE_DURATION,
  OnboardingAction.APPOINTMENT_CREATE_AMOUNT,
  OnboardingAction.APPOINTMENT_CREATE_TYPE,
  OnboardingAction.APPOINTMENT_CREATE_DUE_DATE,
  OnboardingAction.APPOINTMENT_MODAL_SAVE,
  OnboardingAction.WAIT,
  OnboardingAction.APPOINTMENT_CREATED,
  OnboardingAction.AGENDA_NAV_CLOSE,
  // OnboardingAction.CLIENT_PROFILE_BACK_FROM_AGENDA,
  OnboardingAction.CLIENT_PROFILE_VIEW_INVOICES,
  OnboardingAction.CLIENT_PROFILE_LIST_INVOICES,
  OnboardingAction.CLIENT_PROFILE_NEW_PAYMENT,
  // OnboardingAction.PAYMENT_CREATE_DATE,
  // OnboardingAction.PAYMENT_CREATE_AMOUNT,
  // OnboardingAction.PAYMENT_CREATE_METHOD,
  // OnboardingAction.PAYMENT_CREATE_DETAILS,
  // OnboardingAction.PAYMENT_CREATE_INVOICE_LIST,
  // OnboardingAction.PAYMENT_CREATED,
  // // OnboardingAction.PAYMENT_MODAL_CLOSED,
  OnboardingAction.PAYMENT_VIEW_ALL,
  OnboardingAction.VIEW_REPORTS,
  OnboardingAction.REPORT_FILTER_DATE,
  OnboardingAction.REPORT_TOTAL,
  OnboardingAction.REPORT_PAID,
  OnboardingAction.REPORT_PENDING,
  OnboardingAction.REPORT_LIST,
  OnboardingAction.CLOSE
];


@Injectable({
  providedIn: 'root'
})
export class OnboardingService {

  private enabled: boolean = true;

  public isOpen: boolean = false;
  public trigger: string = null;
  public reference: any = null;
  public side: 'top' | 'bottom' | 'left' | 'right' | 'start' | 'end' = 'end';
  public size: 'auto' | 'cover' = 'auto';

  private contentRef: ElementRef;
  public updateContent: (data: string) => void;

  private stepsStack: OnboardingAction[] = [...OnboardingSteps];
  private backStepsStack: OnboardingAction[] = [];

  private addElement = new Subject<{
    element: HTMLElement;
    style: {
      top: number;
      left: number;
      width: number;
      height: number;
    }
  }>();
  public readonly onAddElement$ = this.addElement.asObservable();

  private nextActions: { [key: string]: () => Promise<void> | void } = {};

  public get page(): {current: number; total: number} {
    return {
      current: this.backStepsStack.length,
      total: this.stepsStack.length + this.backStepsStack.length
    }
  }

  public get isDesktop() {
    return this.platform.is('desktop');
  }

  private popover: HTMLIonPopoverElement;

  constructor(
    private observableService: ObservableService,
    private popoverController: PopoverController,
    private nav: NavController,
    private platform: Platform
    // private renderer: Renderer2
    ) { 

      this.nextActions[OnboardingAction.LOGIN] = async () => {
        this.action(OnboardingAction.ONBOARDING_START);
      };

      this.nextActions[OnboardingAction.ONBOARDING_START] = async () => {
        this.nav.navigateForward(`/${PageRoutes.DASHBOARD}/${PageRoutes.CLIENTS}`);
      };

    }

  private async save() {

  }

  public nextAction({ id, delay, offset }: { id?: OnboardingAction; delay?: number; offset?: number; } = {}) {
    delay = delay || 0;
    offset = offset || 0;
    id = id || this.stepsStack[offset];
    if (this.nextActions[id]) {
      this.nextActions[id]();
    } else {
      this.action(id, { delay, offset });
    }
  }

  public syncAction(id: OnboardingAction) {
    if (this.enabled && this.stepsStack[0] != id) {
      const index = this.stepsStack.indexOf(id);
      console.log('syncAction', id, this.stepsStack, this.backStepsStack, index)
      if (index > -1) {
        this.backStepsStack.unshift(...this.stepsStack.splice(0, index + 1).reverse());
      }
      console.log('syncAction', this.stepsStack, this.backStepsStack)
    }

    return this.enabled && this.stepsStack[0] == id;
  }

  public async action(id: OnboardingAction, options: { delay?: number; offset?: number } = { delay: 0 }) {
    setTimeout(async () => {
      console.log('action', new Date(), id, this.stepsStack, this.backStepsStack)
      const offset = options?.offset || 0;
      if (this.enabled && this.stepsStack[offset] == id) {
        // this.show();
        this.observableService.publishOnboardingAction(id);
        this.backStepsStack.unshift(...(this.stepsStack.splice(0, offset + 1).reverse()));
        await this.save();
      }
    }, options?.delay || 0);
  }

  public async back(options: { delay?: number; offset?: number } = { delay: 0 }) {
    if (this.backStepsStack.length > 1) {
      this.stepsStack.unshift(...(this.backStepsStack.splice(0,2).reverse()));
      this.action(this.stepsStack[0], options);
      await this.save();
    }
  }

  public setContentRef(ref: ElementRef) {
    this.contentRef = ref;
  }

  public async show(trigger: string, reference: any, contentElement: any, options: { 
    side?: 'top' | 'bottom' | 'left' | 'right' | 'start' | 'end'; 
    size?: 'auto' | 'cover',
    alignment?: 'start' | 'center' | 'end',
    triggerAction?: () => Promise<void> | void,
    closeAction?: () => Promise<void> | void,
    nextAction?: () => Promise<void> | void,
    backAction?: () => Promise<void> | void,
    hideForwardButton?: boolean,
    hideBackButton?: boolean,
    hideCloseButton?: boolean,
    event?: OnboardingAction,
    title?: string,
    xOffset?: number | string,
    yOffset?: number | string,
    yTriggerAlignment?: 'top' | 'bottom' | 'middle',
    xTriggerAlignment?: 'left' | 'right' | 'center'
  } = {}) {
    
    this.trigger = trigger;
    this.reference = reference;
    this.side = options.side || this.side;
    this.size = options.size || this.size;

    const onUpdate = new Subject<string>();
    const close = async () => {
      await this.close();
      if (options.closeAction) {
        await options.closeAction();
      }
    };


    const popover = this.popover = await this.popoverController.create({
      component: PopoverContentComponent, 
      translucent: true,
      animated: true,
      backdropDismiss: false,
      reference,
      trigger,
      size: options.size,
      side: options.side,
      alignment: options.alignment,
      mode: 'ios',
      cssClass: 'custom-popover-class',
      arrow: true,
      componentProps: {
        contentElement,
        action: options.triggerAction || (() => true),
        close,
        next: async () => {
          await close();

          if (options.nextAction) {
            await options.nextAction();
          } else {
            this.nextAction();
          }
        },
        back: async () => {
          await close();
          this.back();
          if (options.backAction) await options.backAction();
        },
        onUpdate,
        hideForwardButton: options.hideForwardButton,
        hideBackButton: options.hideBackButton,
        hideCloseButton: options.hideCloseButton,
        pagination: this.page,
        title: options.title
      },

    });

    

    await popover.present();
    this.isOpen = true;

    if (options.yTriggerAlignment || options.xTriggerAlignment) {
      const rect = popover.children.item(0).getBoundingClientRect();
      const triggerElement = document.getElementById(trigger);
      const referenceRect = triggerElement.getBoundingClientRect();
      // const popoverHeight = rect.height;
      // const targetHeight = reference.getBoundingClientRect().height;
      // const offsetY = (targetHeight / 2) - (popoverHeight / 2);
      // popover.style.setProperty('--offset-y', `${offsetY}px`);
      // set the offset based on the target element position
      if (options.yTriggerAlignment === 'top') {
        popover.style.setProperty('--offset-y', `${referenceRect.top - (rect.top - rect.height) + (+options.yOffset || 0)}px`);
      } else if (options.yTriggerAlignment === 'bottom') {
        popover.style.setProperty('--offset-y', `${(referenceRect.top + referenceRect.height) - (rect.top - rect.height) + (+options.yOffset || 0)}px`);
      } else if (options.yTriggerAlignment === 'middle') {
        popover.style.setProperty('--offset-y', `${(referenceRect.top + referenceRect.height / 2) - (rect.top - rect.height) + (+options.yOffset || 0)}px`);
      }

      if (options.xTriggerAlignment === 'left') {
        popover.style.setProperty('--offset-x', `${referenceRect.left - (rect.left - rect.width) + (+options.xOffset || 0)}px`);
        console.log("caiu em left", options.xOffset)
      } else if (options.xTriggerAlignment === 'right') {
        popover.style.setProperty('--offset-x', `${(referenceRect.left + referenceRect.width) - (rect.left - rect.width) + (+options.xOffset || 0)}px`);
      } else if (options.xTriggerAlignment === 'center') {
        popover.style.setProperty('--offset-x', `${(referenceRect.left + referenceRect.width / 2) - (rect.left - rect.width) + (+options.xOffset || 0)}px`);
      }
      console.log("Slot:", referenceRect)
      console.log("Popover:", rect)
      console.log('offset', popover.style.getPropertyValue('--offset-y'), popover.style.getPropertyValue('--offset-x'), options.xTriggerAlignment, options.xOffset, +options.xOffset ?? 0)

    }
   
    // const rect = popover.children.item(0).getBoundingClientRect();
    
    // const popoverHeight = rect.height;
    // const targetHeight = reference.getBoundingClientRect().height;
    // const offsetY = (targetHeight / 2) - (popoverHeight / 2);
  
    // popover.style.setProperty('--offset-y', `${offsetY}px`);
  }
  

  public onWillDismiss() {
    this.isOpen = false;
  }

  public onWillPresent() {
    this.isOpen = true;
  }

  public async close() {
    // this.isOpen = false;
    await this.popoverController.dismiss();
  }

  public add(element: HTMLElement, style: {
    top: number;
    left: number;
    width: number;
    height: number;
  }) {
    this.addElement.next({
      element,
      style
    })
  }
}
